import { render, staticRenderFns } from "./Educations.vue?vue&type=template&id=c2c12bb6&scoped=true&"
import script from "./Educations.vue?vue&type=script&lang=js&"
export * from "./Educations.vue?vue&type=script&lang=js&"
import style0 from "./Educations.vue?vue&type=style&index=0&id=c2c12bb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c12bb6",
  null
  
)

export default component.exports